import React, { useEffect, useState, useCallback } from 'react';
import DetailsPageAppbar from '../../../components/common/DetailsPage/DetailsPageAppbar';
import { Main } from '../../../constants/DetailsMain';
import { useParams } from 'react-router-dom';
import { ENQUIRY_COMPANY_RELATED_LIST, ENQUIRY_COMPANY_VIEW, ENQUIRY_LEAD_VIEW, GET_Lead_leadId, GET_LEAD_RELATED_LIST } from '../../../services/apiRoutes';
import axios from 'axios';
// import LeadDetail from './components/OverViewMenu/LeadDetail';
import { useNavigate } from 'react-router-dom';
import CustomCollapse from '../../../components/common/CustomCollapse';
import PersonOutlineOutlinedIcon from '@mui/icons-material/PersonOutlineOutlined';
import CustomLoader from '../../../components/common/CustomLoader';
import { genericPost } from '../../../services/authServices';
import EnquiryLeadDetail from '../DetailsPages/EnquiryLeadDetail';
import { Call } from '../../../components/Leads/OverViewMenu/Call';
import { EnquiryLeadCall } from '../DetailsPages/EnquiryLeadCall';
import { EnquiryLeadTasks } from '../DetailsPages/EnquiryLeadTasks';
import { EnquiryLeadNotes } from '../DetailsPages/EnquiryLeadNotes';
import EnquiryCompanyDetail from '../DetailsPages/EnquiryCompanyDetail';
import { EnquiryCompanyCall } from '../DetailsPages/EnquiryCompanyCall';
import { EnquiryCompanyTasks } from '../DetailsPages/EnquiryCompanyTasks';
import { EnquiryCompanyNotes } from '../DetailsPages/EnquiryCompanyNotes';
import { getBusinessProfile } from '../../../services/CommonServices';

export default function EnquiryLeadDetails() {
    const { clientCompanyId } = useParams();
    const navigate = useNavigate();

    const [open, setOpen] = useState(true);
    const [activeTab, setActiveTab] = useState('Overview');
    const [companyDetails, setCompanyDetails] = useState(null);
    const [relatedList, setRelatedList] = useState([]);
    const [loading, setLoading] = useState(true);
    const [error, setError] = useState(null);

    const handleDrawerOpen = () => setOpen(true);
    const handleDrawerClose = () => setOpen(false);
    const handleScrollTo = (menu) => setActiveTab(menu);
    const businessProfile = getBusinessProfile();
    const basePath =
        businessProfile === "partner"
            ? "/partner"
            : "/alexxcansols";

    const handleBackClick = () => navigate(`${basePath}/company`);

    const AppBarMenu = [{ menu: 'Overview', to: `${basePath}/company/${clientCompanyId}` }];

    const fetchLeadDetails = useCallback(async () => {
        try {
            setLoading(true);
            const authToken = sessionStorage.getItem('accessToken');
            const response = await axios.get(ENQUIRY_COMPANY_VIEW(clientCompanyId), {
                headers: { Authorization: `Bearer ${authToken}` },
            });
            setCompanyDetails(response.data.clientCompany);
        } catch (error) {
            console.error('Error fetching company details:', error);
            setError('Failed to load lead details');
        } finally {
            setLoading(false);
        }
    }, [clientCompanyId]);


    const fetchRelatedList = async () => {
        setError(null);
        try {
            const payload = {
                clientCompanyId: clientCompanyId,
            };
            const response = await genericPost(ENQUIRY_COMPANY_RELATED_LIST, payload);
            if (response.data.success && response.data.buttonList) {
                setRelatedList(response.data.buttonList);
            } else {
                setError('No button list data found');
            }
        } catch (error) {
            setError('Error fetching button list data');
            console.error('Error fetching button list:', error);
        } finally {
        }
    };
    useEffect(() => {
        fetchLeadDetails();
        fetchRelatedList();
    }, [fetchLeadDetails]);


    if (loading) return <CustomLoader open={true} />;
    if (error) return <p>{error}</p>;
    if (!companyDetails) return <p>No company details available.</p>;

    // const { clientCompany, user } = companyDetails;

    const clientCompany = companyDetails || {};
    const user = clientCompany.user || {};

    const clientCompanyName = clientCompany?.companyName || 'N/A';
    const phoneNumber = clientCompany?.mobile || 'N/A';
    const initial = clientCompanyName.charAt(0).toUpperCase();

    const adminData = [
        {
            title: "Company Owner",
            defaultExpanded: false,
            details: [
                { label: 'Company Owner', value: `${user.firstName || ''} ${user.lastName || ''}`.trim() },
                { label: 'Email', value: user.email, sm: 12, md: 12 },
                {
                    label: 'Mobile',
                    value: user?.phonecode?.phonecode && user?.mobile
                        ? `+${user.phonecode.phonecode}${user.mobile}`
                        : user?.mobile || '',
                    sm: 12,
                    md: 12
                },
            ],
        },
    ];

    return (
        <>
            <div>
                <DetailsPageAppbar
                    handleScrollTo={handleScrollTo}
                    activeTab={activeTab}
                    open={open}
                    handleDrawerOpen={handleDrawerOpen}
                    handleDrawerClose={handleDrawerClose}
                    AppBarMenu={AppBarMenu}
                    companyName={clientCompanyName}
                    phoneNumber={phoneNumber}
                    initial={initial}
                    onBackClick={handleBackClick}
                    buttonList={relatedList}
                />

                <Main open={open}>
                    <EnquiryCompanyDetail />
                    <br />
                    <EnquiryCompanyCall clientCompanyId={clientCompanyId} data={clientCompany} />
                    <br />
                    <EnquiryCompanyTasks clientCompanyId={clientCompanyId} data={clientCompany} />
                    <br />
                    <EnquiryCompanyNotes clientCompanyId={clientCompanyId} data={clientCompany} />
                    <br />
                    <CustomCollapse Icon={PersonOutlineOutlinedIcon} data={adminData} />
                    <br />
                </Main>
            </div>
        </>
    );
}


